/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import styled, { css } from 'styled-components';
import CheckIconAlt from '@src/svgs/CheckIconAlt';
import { AudienceOption } from './AudienceSelector';

interface AudienceFilterComponentProps {
  audiences: AudienceOption[];
  selectedAudiences: AudienceOption[];
  setSelectedAudiences: (audiences: AudienceOption[]) => void;
  useAudienceFilter: boolean;
  setUseAudienceFilter: (
    useFilter: boolean | ((prev: boolean) => boolean),
  ) => void;
  title?: string;
  align?: 'center' | 'left';
}

const AudienceFilterComponent: React.FC<AudienceFilterComponentProps> = ({
  audiences,
  selectedAudiences,
  setSelectedAudiences,
  useAudienceFilter,
  setUseAudienceFilter,
  title = 'Target Audiences',
  align = 'center',
}) => {
  const handleAudienceToggle = (audience: AudienceOption) => {
    const isSelected = selectedAudiences.some(a => a.id === audience.id);

    if (isSelected) {
      setSelectedAudiences(selectedAudiences.filter(a => a.id !== audience.id));
    } else {
      setSelectedAudiences([...selectedAudiences, audience]);
    }
  };

  return (
    <AudienceFilterSection>
      <CheckBoxContainer
        onClick={() => setUseAudienceFilter(prev => !prev)}
        disabled={audiences.length === 0}
        align={align}
      >
        <CheckBox isChecked={useAudienceFilter} role="button">
          {useAudienceFilter && <CheckIconAlt />}
        </CheckBox>
        <div className="checkbox-text">{title}</div>
      </CheckBoxContainer>

      {useAudienceFilter && audiences.length > 0 && (
        <AudienceGrid>
          {audiences.map(audience => {
            const isSelected = selectedAudiences.some(
              a => a.id === audience.id,
            );
            return (
              <AudienceItem
                key={audience.id}
                selected={isSelected}
                onClick={() => handleAudienceToggle(audience)}
              >
                <AudienceLabel>{audience.label}</AudienceLabel>
                <AudienceCheckmark selected={isSelected}>
                  {isSelected && '✓'}
                </AudienceCheckmark>
              </AudienceItem>
            );
          })}
        </AudienceGrid>
      )}
    </AudienceFilterSection>
  );
};

export default AudienceFilterComponent;

// Styled components
const AudienceFilterSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CheckBoxContainer = styled.div<{
  disabled: boolean;
  align: 'center' | 'left';
}>`
  display: flex;
  align-items: center;
  justify-content: ${props => props.align};
  gap: 8px;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  opacity: ${props => (props.disabled ? 0.5 : 1)};

  .checkbox-text {
    color: #f3e9d7;
    font-size: 12px;
    line-height: 140%;
    text-align: ${props => props.align};
  }
`;

const CheckBox = styled.div<{ isChecked: boolean }>`
  background-color: ${props => (props.isChecked ? '#4AD067' : 'transparent')};
  width: 16px;
  height: 16px;
  border-radius: 2px;
  overflow: hidden;
  border: ${props => (props.isChecked ? 'none' : '1px solid #9B9B9B')};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`;

const AudienceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  width: 100%;
  margin-top: 8px;
`;

const AudienceItem = styled.div<{ selected: boolean }>`
  padding: 8px;
  position: relative;
  border-radius: 8px;
  box-sizing: border-box;
  border: 1px solid ${props => (props.selected ? '#f2d093' : '#5d5d5d')};
  background-color: ${props =>
    props.selected ? 'rgba(242, 208, 147, 0.1)' : 'transparent'};
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    border-color: #f2d093;
  }
`;

const AudienceLabel = styled.span`
  color: #f3e9d7;
  font-size: 10px;
  font-weight: 500;
  line-height: 150%;
  flex: 1;
  padding-right: 8px;
`;

const AudienceCheckmark = styled.div<{ selected: boolean }>`
  width: 14px;
  height: 14px;
  border-radius: 14px;
  border: 1px solid ${props => (props.selected ? '#4ad067' : '#949494')};
  background: ${props => (props.selected ? '#030419' : 'transparent')};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 600;
  color: #4ad067;
  flex-shrink: 0;
`;
